import { LitElement } from "lit";
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from "@lingui/core";

var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  var _a;
  let value;
  switch ((_a = process == null ? void 0 : process.env) == null ? void 0 : _a.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname == null ? void 0 : hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg, daMsg, svMsg) => {
  if (locale === "nb") return nbMsg;
  if (locale === "fi") return fiMsg;
  if (locale === "da") return daMsg;
  if (locale === "sv") return svMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages, daMessages, svMessages) => {
  const locale = detectLocale();
  const messages = getMessages(locale, enMessages, nbMessages, fiMessages, daMessages, svMessages);
  i18n.load(locale, messages);
  i18n.activate(locale);
};

var msgs = { "nb": { "icon.title.remppatorilight": ["Remppatori lyst ikon"] }, "en": { "icon.title.remppatorilight": ["RemppaTori"] }, "fi": { "icon.title.remppatorilight": ["Remppatori"] }, "da": { "icon.title.remppatorilight": ["Remppatori lyst ikon"] }, "sv": { "icon.title.remppatorilight": ["RemppaTori"] } };
activateI18n(msgs.en, msgs.nb, msgs.fi, msgs.da, msgs.sv);
var IconRemppatoriLight42 = class extends LitElement {
  render() {
    const title = i18n.t({ message: `RemppaTori`, id: "icon.title.remppatorilight", comment: "Title for RemppatoriLight icon" });
    return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28">${unsafeStatic(`<title>${title}</title>`)}<path fill="#101F41" d="M17.08 1.961 7.002 12.007l2.8 2.791 10.08-10.046-2.8-2.79Z"></path><path fill="#3960BF" d="M15.96 10.89a3.967 3.967 0 0 0 5.6 0l3.36-3.348 7.28 7.256 2.8-2.79L24.92 1.96z"></path><path fill="#101F41" d="M22.68 12.007a5.553 5.553 0 0 1-7.839 0l-3.92 3.907 10.08 10.047 1.68-1.675-3.92-3.907 1.12-1.116 3.92 3.907 1.68-1.675-3.92-3.906 1.12-1.117 3.92 3.907 1.68-1.674-3.92-3.907 1.12-1.116 3.92 3.907 1.68-1.675-6.16-6.14z"></path></svg>`;
  }
};
if (!customElements.get("fp-icon-remppatori-light-42")) {
  customElements.define("fp-icon-remppatori-light-42", IconRemppatoriLight42);
}
export {
  IconRemppatoriLight42
};
